import styles from './W_PaymentOperationInfo.module.css';
import cn from 'classnames';
import { useLanguage } from '@/contexts/LanguageContext';
import { getTranslation } from '@/constants/translations';

interface W_PaymentOperationInfoProps {
  remainingTime: string;
  requestId: number;
}

export default function W_PaymentOperationInfo({
  remainingTime,
  requestId,
}: W_PaymentOperationInfoProps) {
  const { language } = useLanguage();
  const t = (key: string) => getTranslation(language, key);
  return (
    <div className={styles.wrapper}>
      <p className={cn(styles.text, 'text-p-6')}>
        {t('payment.operationInfo.remaining')} {remainingTime}
      </p>
      <p className={cn(styles.text, 'text-p-7')}>
        {t('payment.operationInfo.requestId')}: {requestId}
      </p>
    </div>
  );
}
